const PrimaryButton = ({ text, onClick, cls }) => {
  return (
    <button
      onClick={onClick}
      className={`linear mt-1 h-fit rounded-lg bg-btnGreen-normal px-3
            py-[3px] text-[14px] font-semibold text-white 
            shadow-md transition duration-200 
            hover:bg-btnGreen-hover active:bg-btnGreen-active ${cls}`}
    >
      {text}
    </button>
  );
};

export default PrimaryButton;
